import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initParallaxImage(wrapper) {
  const img = wrapper.querySelector("img");
  if (!img) return;

  const mm = gsap.matchMedia();

  mm.add("(prefers-reduced-motion: no-preference)", () => {
    const tween = gsap.fromTo(
      img,
      { y: 0 },
      {
        y: () => wrapper.offsetHeight - img.offsetHeight,
        ease: "none",
        scrollTrigger: {
          trigger: wrapper,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
          invalidateOnRefresh: true,
        },
      },
    );

    if (img instanceof HTMLImageElement && !img.complete) {
      img.addEventListener("load", () => ScrollTrigger.refresh(), { once: true });
    }

    return () => {
      tween.scrollTrigger?.kill();
      tween.kill();
    };
  });
}

export function initParallaxImages() {
  document.querySelectorAll("[data-parallax-image]").forEach(initParallaxImage);
}
